export const INK = '#25302C';
export const ORANGE = '#FF7E1D';
/** The card's own colour: whatever is filled with it hides the lines behind it. */
export const CARD = '#FFEDDF';
export const LINE = { stroke: INK, strokeWidth: 4, strokeLinecap: 'round', strokeLinejoin: 'round' } as const;

/** Seconds per loop of the whole scene. */
export const LOOP = 6;
